import LayoutPrimary from '../../layouts/Primary';
import SiteCreate from '../../views/Public/SiteCreate';
import ReportSiteSingle from '@/reports/ReportSiteSingle';

export default [
    {
        path: '/site/create/:id',
        name: 'SiteCreate',
        component: SiteCreate,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },

    {
        path: '/site/single/:id',
        name: 'SiteSingle',
        component: ReportSiteSingle,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        }
    }
];
